'use strict';

const { setWishlistIconInList } = require('../product/wishlistHeart');

function checkWishlistListInStorage() {
    if (document.querySelectorAll("div.product.cc-product").length) {
        if (wishlistGetListUrl) {
            $.ajax({
                url: wishlistGetListUrl,
                type: 'post',
                dataType: 'json',
                success: function (data) {
                    sessionStorage.setItem('wishlistList', data.wishlistList);
                    setWishlistIconInList(true);
                }
            });
        } else {
            setWishlistIconInList(true);
        }
    }
}

checkWishlistListInStorage();